module.exports = __webpack_public_path__ + "static/media/tenant_domuneo_in.3e936e86.svg";